import React, {Component} from 'react';
import {numberFormat} from '../utils/number';

export default class Top10Suppliers extends Component {
    render() {
        const {data} = this.props;

        return (
            <div className="x_panel">
                <div className="x_title">
                    <h2>
                        <i className="fa fa-angle-right"></i> {window.__js_dashboard.top_10_suppliers}
                    </h2>
                    <div className="clearfix"></div>
                </div>
                <div className="x_content">
                    <div className="table-responsive">
                        <table className="table table-hover table-striped table-bordered">
                            <thead>
                            <tr>
                                <th>Α/Α</th>
                                <th>{window.__js_dashboard.supplier_company_name}</th>
                                <th>{window.__js_dashboard.supplier_vat_number}</th>
                                <th>{window.__js_dashboard.awarded_amount}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                data.length === 0
                                    ? <tr>
                                        <td colSpan={4}>
                                            <em>{window.__js_dashboard.no_search_results}</em>
                                        </td>
                                    </tr>
                                    : null
                            }
                            {
                                data.map((item, index) => {
                                    return (
                                        <tr key={item.vat_number}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {
                                                    item.user_id
                                                        ? <a href={`/suppliers/view/${item.user_id}`} target="_blank">
                                                            {item.company_name}
                                                        </a>
                                                        : item.company_name
                                                }
                                            </td>
                                            <td>{item.vat_number}</td>
                                            <td>
                                                {numberFormat(item.total, 2, ',', '.')} €
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}